@if (isFetchingInformation) {
  <app-spinner />
} @else if (!info) {
  <div>Ingen informasjon funnet</div>
} @else {
  <div class="information-title">
    <app-ice-info-icon />
    <span>{{ info.explanationTitle }}</span>
  </div>
  @if (!!isInquiredControlOSAffected) {
    <div>
      <mat-button-toggle-group
        hideSingleSelectionIndicator
        [value]="activeOS$.value"
        (change)="activeOS$.next($event.value)"
      >
        <mat-button-toggle value="Android">Android</mat-button-toggle>
        <mat-button-toggle value="Ios">iPhone</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  }
  <div class="rich-text" [innerHTML]="info.htmlFirstRichText"></div>
  @for (image of info.images; track $index) {
    <div class="information-image">
      <img [alt]="image.alt" [src]="image.imageUrl" />
      <div [innerHTML]="image.htmlDescription"></div>
    </div>
  }
  @if (!!info.htmlSecondRichText) {
    <div class="rich-text" [innerHTML]="info.htmlSecondRichText"></div>
  }
}
